import React, { Component } from 'react'
import { Button, Col, Row, Label } from 'reactstrap'
import { observer, inject } from 'mobx-react'
import CardAcomp from './CardAcomp'

@inject("store")
@observer
export default class DetalhesAcompMobile extends Component {

    constructor(props){
        super(props)
        
        this.controller = this.props.controller
    }

    renderAvaria() {
        if(this.controller.tipoAcompanhamento !== "E"){
            if(this.controller.tipoAcompanhamento === "C" && process.env.rig){
                return null
            }else{
                return(
                    <div>
                        <h3 className="text-center">
                            Avaria
                        </h3>
                        {this.controller.dadosContainers.map((container, index) => 
                            <CardAcomp
                                key={index}
                                data={container}
                                id={index}
                                colunas={[...this.controller.colunasAvaria]}
                            />    
                        )}
                    </div>
                )
            }
        }
    }

    renderNotaFiscal() {
        if(this.controller.tipoAcompanhamento !== "E" && !process.env.rig){
            return(
                <div>
                    <h3 className="text-center">
                        Notas fiscais emitidas - Faturamento
                    </h3>
                    {this.controller.dadosNF.map((container, index) => 
                        <CardAcomp
                            key={index}
                            data={container}
                            id={index}
                            colunas={[...this.controller.colunasNF]}
                        />    
                    )}
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Col>
                        <h2>
                            Detalhes do Processo
                        </h2>
                    </Col>
                    <Col>
                        {!process.env.rig && !this.controller.desistencia && <Button
                            className="float-right btn-com-bordas-primary"
                            onClick={() => this.controller.abrirDesistencia()}
                        >
                            Desistir da vistoria
                        </Button>}
                    </Col>
                </Row>
                {this.renderAvaria()}
                <div>
                    <h3 className="text-center">
                        {this.controller.tipoAcompanhamento !== "E" ? "Detalhes dos containers" : "Dados Containers"}
                    </h3>
                    {this.controller.dadosContainers.map((container, index) => 
                        <CardAcomp
                            key={index}
                            data={container}
                            id={index}
                            colunas={[...this.controller.colunasCntr]}
                        />    
                    )}
                </div>
                {this.renderNotaFiscal()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/DetalhesAcompMobile.js